import { ReactElement, memo } from 'react';
import { Stack, Typography } from '@mui/material';

import UserInfo from '../UserInfo';

import { LastOrderEventInfoProps } from './types';

const LastOrderEventInfo = ({
  description,
  user,
}: LastOrderEventInfoProps): ReactElement => (
  <Stack spacing={0.5}>
    <Typography variant="body2" fontWeight="bold">
      {description}
    </Typography>

    <UserInfo {...user} fontSize={11} />
  </Stack>
);

export default memo(LastOrderEventInfo);
